import { createContext, useState, useEffect } from 'react'
 

export const intentsContext = createContext()

export function IntentsProvider({ children }) {
  const [state, setState] = useState({answers: [], answerSelected: null})

  const updateState = async (value, name, callback) => { 
    setState({ ...state, [name]: value }); 
    if(callback) callback(); 
}
  const valuecontext = {
    state, 
    updateState,
    setState 
  }
 
  return (
    <intentsContext.Provider value={valuecontext}>
      {children}
    </intentsContext.Provider>
  )
}
